import { getCookie } from '../utils/cookiesUtils';
var FORCE_ANALYTICS_COOKIE = 'force_analytics';
var REAUID_COOKIE = 'reauid';
var forceAnalyticsCookieDefault = getCookie(FORCE_ANALYTICS_COOKIE);
var reauidCookieDefault = getCookie(REAUID_COOKIE);

var shouldTrackEvent = function shouldTrackEvent(tracking) {
  var forceAnalyticsCookie = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : forceAnalyticsCookieDefault;
  var reauidCookie = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : reauidCookieDefault;

  if (!tracking) {
    return false;
  }

  var _tracking$percentage = tracking.percentage,
      percentage = _tracking$percentage === void 0 ? 0 : _tracking$percentage;

  if (forceAnalyticsCookie === 'true') {
    return true;
  }

  if (forceAnalyticsCookie === 'false') {
    return false;
  }

  if (!reauidCookie) {
    return false;
  }

  var uidNumber = parseInt(reauidCookie, 16) || 0;
  return uidNumber >= 0 && uidNumber % 100 < percentage;
};

export default shouldTrackEvent;
//# sourceMappingURL=shouldTrackEvent.js.map